import React, { Suspense } from "react";

import { Box, GDSBoxProps, GDSStyleObject } from "@leagueplatform/genesis-core";
import { useScrollTopOnLocationChange } from "@leagueplatform/web-common";
import { ObservabilityErrorBoundary } from "@leagueplatform/observability";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { HEADER_NAV_BAR_DEFAULT_HEIGHT } from "@leagueplatform/solutions-foundation";
import { AppNavBarComponent } from "components/header-nav/header-nav.component";
import { AppFooter } from "components/app-footer/app-footer.component";
import { QueryParamModal } from "components/query-param-modal/query-param-modal.component";
import { GenericError } from "components/generic-error/generic-error";

type BasePageProps = GDSBoxProps<"div"> & {
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
};

export const BasePage: React.FC<BasePageProps> = ({
  children,
  isPrivatePage = true,
  css,
  ...boxProps
}) => {
  useScrollTopOnLocationChange();

  const mainContentMinHeight = isPrivatePage
    ? `calc(100vh - ${HEADER_NAV_BAR_DEFAULT_HEIGHT}px)`
    : "100vh";

  return (
    <>
      {isPrivatePage && <AppNavBarComponent />}
      <Box
        as="main"
        id="main-content"
        css={{
          position: "relative",
          flex: "1",
          minHeight: mainContentMinHeight,
          marginBlockEnd: isPrivatePage ? "$five" : "$none",
          overflowX: "hidden",
          ...css,
        }}
        {...boxProps}
      >
        <Suspense fallback={<LoadingIndicator />}>
          <ObservabilityErrorBoundary
            fallback={<GenericError />}
            errorContext={{
              context: {
                Context: { location: "Base Page ErrorBoundary" },
              },
            }}
          >
            {children}
            {isPrivatePage && <QueryParamModal />}
          </ObservabilityErrorBoundary>
        </Suspense>
      </Box>
      {isPrivatePage && <AppFooter />}
    </>
  );
};
